import React, { useState } from "react";
import {
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Select,
  MenuItem,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";

const Users = () => {
  const [users, setUsers] = useState([
    {
      id: 1,
      name: "John Doe",
      email: "john@example.com",
      status: "Active",
      wallet: 100,
    },
    {
      id: 2,
      name: "Jane Smith",
      email: "jane@example.com",
      status: "Blocked",
      wallet: 50,
    },
    {
      id: 3,
      name: "Alice Brown",
      email: "alice@example.com",
      status: "Active",
      wallet: 200,
    },
    {
      id: 4,
      name: "Bob Johnson",
      email: "bob@example.com",
      status: "Blocked",
      wallet: 0,
    },
  ]);

  const [filter, setFilter] = useState("All");
  const [selectedUser, setSelectedUser] = useState(null);
  const [amount, setAmount] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRefund, setIsRefund] = useState(false);

  const toggleUserStatus = (id) => {
    setUsers((prevUsers) =>
      prevUsers.map((user) =>
        user.id === id
          ? { ...user, status: user.status === "Active" ? "Blocked" : "Active" }
          : user
      )
    );
  };

  const openModal = (user, refund = false) => {
    setSelectedUser(user);
    setAmount("");
    setIsRefund(refund);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedUser(null);
    setAmount("");
    setIsModalOpen(false);
  };

  const addFunds = () => {
    setUsers((prevUsers) =>
      prevUsers.map((user) =>
        user.id === selectedUser.id
          ? { ...user, wallet: user.wallet + parseFloat(amount) }
          : user
      )
    );
    closeModal();
  };

  const refundFunds = () => {
    setUsers((prevUsers) =>
      prevUsers.map((user) =>
        user.id === selectedUser.id
          ? { ...user, wallet: user.wallet - parseFloat(amount) }
          : user
      )
    );
    closeModal();
  };

  const filteredUsers = users.filter((user) =>
    filter === "All" ? true : user.status === filter
  );

  return (
    <Box sx={{ padding: "20px", backgroundColor: "#f5f5f5", minHeight: "100vh" }}>
      {/* Header Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
      

        <Select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          displayEmpty
          sx={{
            width: "80px",
            padding: "2px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            backgroundColor: "#fff",
          }}
        >
          <MenuItem value="All">All</MenuItem>
          <MenuItem value="Active">Active</MenuItem>
          <MenuItem value="Blocked">Blocked</MenuItem>
        </Select>
      </Box>

      {/* User Table */}
      <Table
        sx={{
          backgroundColor: "#fff",
          borderRadius: "10px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <TableHead>
          <TableRow sx={{ backgroundColor: "#007bff", color: "#fff" }}>
            <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>ID</TableCell>
            <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Name</TableCell>
            <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Email</TableCell>
            <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Status</TableCell>
            <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Wallet Balance</TableCell>
            <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredUsers.map((user) => (
            <TableRow
              key={user.id}
              sx={{
                "&:hover": { backgroundColor: "#f9f9f9" },
                transition: "background-color 0.3s",
              }}
            >
              <TableCell>{user.id}</TableCell>
              <TableCell>{user.name}</TableCell>
              <TableCell>{user.email}</TableCell>
              <TableCell>{user.status}</TableCell>
              <TableCell>${user.wallet.toFixed(2)}</TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color={user.status === "Active" ? "secondary" : "primary"}
                  onClick={() => toggleUserStatus(user.id)}
                  sx={{ marginRight: "10px", borderRadius: "20px" }}
                >
                  {user.status === "Active" ? "Block" : "Unblock"}
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => openModal(user)}
                  sx={{ marginRight: "10px", borderRadius: "20px" }}
                >
                  Add Funds
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => openModal(user, true)}
                  sx={{ borderRadius: "20px" }}
                >
                  Refund
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Add Funds or Refund Modal */}
      <Dialog open={isModalOpen} onClose={closeModal}>
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            backgroundColor: isRefund ? "#dc3545" : "#28a745",
            color: "#fff",
          }}
        >
          {isRefund ? "Refund Funds" : "Add Funds to Wallet"}
        </DialogTitle>
        <DialogContent>
          {selectedUser && (
            <Box>
              <p>
                {isRefund ? "Refunding funds for:" : "Adding funds for:"}{" "}
                <strong>{selectedUser.name}</strong>
              </p>
              <TextField
                label="Amount"
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                fullWidth
                sx={{
                  marginTop: "1rem",
                  "& .MuiInputBase-root": {
                    borderRadius: "10px",
                  },
                }}
                error={
                  isRefund &&
                  selectedUser &&
                  parseFloat(amount) > selectedUser.wallet
                }
                helperText={
                  isRefund &&
                  selectedUser &&
                  parseFloat(amount) > selectedUser.wallet &&
                  "Amount exceeds wallet balance"
                }
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModal} color="secondary" sx={{ borderRadius: "20px" }}>
            Cancel
          </Button>
          <Button
            onClick={isRefund ? refundFunds : addFunds}
            color={isRefund ? "error" : "primary"}
            sx={{ borderRadius: "20px" }}
            disabled={
              !amount ||
              parseFloat(amount) <= 0 ||
              (isRefund && parseFloat(amount) > selectedUser.wallet)
            }
          >
            {isRefund ? "Refund" : "Add Funds"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Users;
